export default "__VITE_ASSET__4c190083__"